import { FormConfig } from '@/Modules/Forms/models'
import { AxiosError } from 'axios'
import * as _ from 'lodash-es'
import moment from 'moment'
import { Component, MapGetter, Prop, Vue, Watch } from 'types-vue'
import { FilesApi } from '../../connections/api/Files'
import { Store } from '@/Core/Models/Stores'
import { SystemSubject } from '@/Modules/Auth/models'
const CORE_URL = process.env.VUE_APP_CORE_URL

@Component
export default class P02 extends Vue {
  protected showForm: boolean = true
  protected formData: any = {}
  protected loading: boolean = false
  protected errors: string[] = []
  protected keyname: string = null
  protected defaultDispatchingCompany: string = null
  protected disabledDispatchingCompany: boolean = false
  protected isCnaeRequired: boolean = false
  protected isProtectedtypeRequired: boolean = false
  protected isEssentialtypeRequired: boolean = false

  @MapGetter(Store.UserGroups) protected systemSubject: SystemSubject

  protected get formOptions(): FormConfig {
    return {
      label: 'Inicio',
      submitButton: 'Crear proceso',
      items: [
        {
          type: 'select',
          name: 'dispatchingcompany',
          label: 'Empresa Emisora del Paso',
          options: `${CORE_URL}/system-subjects?categories=COM,CLI`,
          placeholder: 'Selecciona empresa',
          valueQuery: 'code',
          default: this.defaultDispatchingCompany,
          disabled: this.disabledDispatchingCompany
        },
        {
          type: 'select',
          name: 'destinycompany',
          label: 'Empresa Receptora del Paso',
          options: `${CORE_URL}/system-subjects?categories=GRE,DIS`,
          placeholder: 'Selecciona empresa',
          valueQuery: 'code'
        },
        {
          type: 'text',
          name: 'comreferencenum',
          label: 'Referencia',
          placeholder: 'Introduce el numero de referencia'
        },
        {
          type: 'select',
          name: 'titulartype',
          label: 'Tipo de titular',
          placeholder: 'Selecciona el tipo de titular',
          options: `${CORE_URL}/client-person-types`,
          valueQuery: 'code'
        },
        {
          type: 'select',
          name: 'nationality',
          label: 'Nacionalidad',
          placeholder: 'Selecciona la nacionalidad',
          options: `${CORE_URL}/location-nationalities`,
          valueQuery: 'code'
        },
        {
          type: 'select',
          name: 'documenttype',
          label: 'Tipo Documento de Identificación',
          placeholder: 'Selecciona el tipo de documento',
          options: `${CORE_URL}/client-document-types`,
          valueQuery: 'code'
        },
        {
          type: 'text',
          name: 'documentnum',
          label: 'Nº Documento',
          placeholder: 'Escribe el número de documento'
        },
        {
          type: 'text',
          name: 'cups',
          label: 'CUPS Solicitud',
          placeholder: 'Introduce el CUPS',
          valueQuery: 'code'
        },
        {
          type: 'text',
          name: 'reqqd',
          label: 'Caudal diario Qd',
          placeholder: 'Introduce el Caudal diario',
          valueQuery: 'code'
        },
        {
          type: 'text',
          name: 'reqestimatedqa',
          label: 'Caudal Estimado Anual Qa',
          placeholder: 'Introduce el caudal estimado anual',
          valueQuery: 'code'
        },
        {
          type: 'select',
          name: 'modeffectdate',
          label: 'Modelo Fecha Efecto',
          options: `${CORE_URL}/contract-effect-date-models`,
          placeholder: 'Introduce modelo fecha efecto',
          valueQuery: 'code'
        },
        {
          type: 'date',
          name: 'reqtransferdate',
          label: 'Fecha de Efecto Solicitada',
          placeholder: 'Introduce la fecha efecto solicitada'
        },
        {
          type: 'text',
          name: 'readingvalue',
          label: 'Lectura',
          placeholder: 'Lectura aportada'
        },
        {
          type: 'select',
          name: 'cnae',
          label: 'CNAE',
          options: `${CORE_URL}/cnaes`,
          placeholder: 'Selecciona CNAE',
          valueQuery: 'code',
          //default: this.cnae
        },
        {
          type: 'select',
          name: 'protectedtype',
          label: 'Tipo de cliente protegido',
          options: `${CORE_URL}/protected-clients`,
          placeholder: 'Tipo de cliente protegido',
          valueQuery: 'code',
          //default: this.protectedtype
        },
        {
          type: 'select',
          name: 'essentialtype',
          label: 'Tipo de cliente esencial',
          options: `${CORE_URL}/essential-clients`,
          placeholder: 'Tipo de cliente esencial',
          valueQuery: 'code',
          //default: this.essentialtype
        },
        {
          type: 'switch',
          name: 'disconnectedserviceaccepted',
          label: 'Contratar independientemente del estado',
          placeholder: 'Selecciona si deseas contratar independientemente del estado'
        }
      ],
      rules: {
        dispatchingcompany: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        destinycompany: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        comreferencenum: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        reqdate: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        reqhour: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        nationality: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        documenttype: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        documentnum: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        cups: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        modeffectdate: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        disconnectedserviceaccepted: [
          { required: true, trigger: 'blur', message: 'Es obligatorio' },
        ],
        cnae: [
          {
          required: this.isCnaeRequired,
          trigger: 'blur',
          message: 'Es obligatorio si alguno de los campos tipo de cliente protegido o tipo de cliente esencial tienen valor'
          }
        ],
        protectedtype: [
          {
          required: this.isProtectedtypeRequired,
          trigger: 'blur',
          message: 'Es obligatorio si alguno de los campos CNAE o tipo de cliente esencial tienen valor'
          }
        ],
        essentialtype: [
          {
          required: this.isEssentialtypeRequired,
          trigger: 'blur',
          message: 'Es obligatorio si alguno de los campos CNAE o tipo de cliente protegido tienen valor'
          }
        ],
      }
    }
  }

  private updateFormData(newData: any) {
    this.formData = { ...this.formData, ...newData }
  }

  private getProcessData() {
    const currentDate = moment().format('YYYY-MM-DD')
    const currentHour = moment().format('hh:mm:ss')

    return {
      heading: {
        dispatchingcode: 'GML',
        dispatchingcompany: this.formData?.dispatchingcompany,
        destinycompany: this.formData?.destinycompany,
        communicationsdate: currentDate,
        communicationshour: currentHour,
        processcode: '02',
        messagetype: 'A1'
      },
      a102: [
        {
          comreferencenum: this.formData?.comreferencenum,
          reqdate: currentDate,
          reqhour: currentHour,
          titulartype: this.formData?.titulartype,
          nationality: this.formData?.nationality,
          documenttype: this.formData?.documenttype,
          documentnum: this.formData?.documentnum,
          cups: this.formData?.cups,
          reqqd: this.formData?.reqqd,
          reqestimatedqa: this.formData?.reqestimatedqa,
          modeffectdate: this.formData?.modeffectdate,
          reqtransferdate: this.formData?.reqtransferdate
            ? moment(this.formData?.reqtransferdate).format('YYYY-MM-DD')
            : this.formData?.reqtransferdate,
          disconnectedserviceaccepted: this.formData?.disconnectedserviceaccepted ? 'S' : 'N',
          readingvalue: this.formData?.readingvalue,
          cnae: this.formData?.cnae,
          protectedtype: this.formData?.protectedtype,
          essentialtype: this.formData?.essentialtype,
        }
      ]
    }
  }

   protected async change(process: any) {

      const cnae = process.cnae;
      const protectedtype = process.protectedtype;
      const essentialtype = process.essentialtype;

      this.isProtectedtypeRequired = false;
      this.isEssentialtypeRequired = false;
      this.isCnaeRequired = false;

      // FORM CONSTANTS.
      // CNAE LOGIC.
      if (cnae !== "" && cnae !== null) {
        this.isProtectedtypeRequired = true;
        this.isEssentialtypeRequired = true;
      }
      // PROTECTED TYPE LOGIC.
      if (protectedtype !== "" && protectedtype !== null) {
        this.isCnaeRequired= true;
        this.isEssentialtypeRequired = true;
      }
      // ESSENTIAL TYPE LOGIC.
      if (essentialtype !== "" && essentialtype !== null) {
        this.isCnaeRequired = true;
        this.isProtectedtypeRequired = true;
      }

   }
  /**
   * FORMS CALLBACKS
   */

  protected async onSubmit(newData: any) {

    this.updateFormData(newData)
    const process = this.getProcessData()

    try {
      this.loading = true
      this.showForm = false

      const response = await FilesApi.generateProcess(process)

      this.errors = response.data.body.error
      this.keyname = response.data.keyname
    } catch (err) {
      const error = err as AxiosError
      const messagaError = error?.response?.data?.message || 'Error al cargar las facturas.'

      this.$notify.error({ title: `Error ${error?.response?.status}`, message: messagaError })
    } finally {
      this.loading = false
    }
  }

  protected handleReturn() {
    this.showForm = true
  }

  @Watch('systemSubject', { deep: true, immediate: true })
  protected onChangeSystemSubject() {
    const specialSubjects = ['0000', '0234']

    if (this.systemSubject.code && !specialSubjects.includes(this.systemSubject.code)) {
      this.defaultDispatchingCompany = this.systemSubject.code
      this.disabledDispatchingCompany = true
    }
  }
}
